// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"d171d876","129":"de218d2f","150":"d4ed9f8f","208":"18b8dbd6","255":"5ef7060a","385":"3283a76c","400":"f9b284c4","463":"ee542aaa","623":"c3fd859d","637":"e6d87a62","725":"8e095c9d","728":"b9e7f76d","887":"e95deb73","920":"0e8681d1"}[chunkId] + ".chunk.js";
};